<template>
  <div>
    <!-- Title -->
    <h5 class="mt-3 mb-2">{{ title }}</h5>

    <!-- Description -->
    <p v-if="description" class="mb-0">
      {{ description }}
    </p>

    <!-- Buttons -->
    <div class="d-flex flex-row justify-content-end mt-4 h-35">
      <!-- Router -->
      <router-link
        v-if="to"
        :to="to"
        class="btn btn-portal w-100 max-width-200 rounded-75 d-flex align-items-center justify-content-center"
      >
        Ver
      </router-link>

      <!-- Link / Coordinates -->
      <a
        v-else-if="href || (coordinates && coordinates.length === 2)"
        :href="coordinates
            ? `https://www.google.com/maps?q=${coordinates[0]},${coordinates[1]}`
            : href"
        target="_blank"
        class="btn btn-portal w-100 max-width-200 rounded-75 d-flex align-items-center justify-content-center"
      >
        Ver
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },

    description: {
      type: String,
      required: true
    },

    to: {
      type: [String, Object],
      default: null
    },

    href: {
      type: String,
      default: null
    },

    coordinates: {
      type: Array,
      default: null,
      validator: value => value === null || value.length === 2
    }
  }
}
</script>